import { trackEvent } from '@kcd/event-tracker';

import NonLoginShoppingCartButton from '~/components/NonLogin/NonLoginShoppingCartButton';
import { VENDORS_ROUTER } from '~/constants/router';
import { useCurrentUser } from '~/domains/auth/queries';
import ShoppingCartButton from '~/domains/cart/ShoppingCartButton';
import DeliveryFlag from '~/domains/delivery/DeliveryFlag';
import ProductPrice from '~/domains/products/components/ProductPrice';
import ProductSalesTargetBadge from '~/domains/products/components/ProductSalesTargetBadge';
import { useLinkComponent } from '~/hooks/mobileApp';
import type { OAISchema } from '~/types/openapi';

type Props = {
  product: OAISchema['MarketSelectProductResponseV2'];
  index: number;
};

const PopularProductItem = ({ product, index }: Props) => {
  const LinkComponent = useLinkComponent();
  const { user, isLoggedIn } = useCurrentUser();

  const onClickProduct = () => {
    trackEvent('clicked 캐시노트마켓 product', {
      productId: product.offerId,
      productName: product.productName,
      userId: user?.trackingId,
      buyerId: user?.id,
      placementName: '홈/인기상품',
    });
  };

  const onClickCart = () => {
    trackEvent('clicked 마켓/홈 cart in 인기상품', {
      productId: product.offerId,
      productName: product.productName,
      userId: user?.trackingId,
      buyerId: user?.id,
      placementName: '홈/인기상품',
    });
  };

  return (
    <div className="not:last-of-type:mb-12 relative flex items-center">
      <div
        className="relative mr-8 box-border h-[92px] shrink-0 basis-[92px] overflow-hidden rounded-12 border border-solid border-02"
        role="presentation"
        onClick={onClickProduct}
      >
        <p className="absolute left-8 top-8 z-10 flex size-24 items-center justify-center rounded-[8px] bg-primary-regular text-gray-000 typo-paragraph300-semibold">
          {index}
        </p>
        <LinkComponent
          href={VENDORS_ROUTER.productDetail(
            product.vendorId,
            product.offerId!,
          )}
        >
          <img
            className="size-[90px] object-cover"
            alt="인기상품 아이템"
            src={product.mainImages![0]}
          />
        </LinkComponent>
      </div>
      <div
        role="presentation"
        onClick={onClickProduct}
        className="flex flex-auto flex-col justify-center overflow-hidden"
      >
        <LinkComponent
          href={VENDORS_ROUTER.productDetail(
            product.vendorId,
            product.offerId!,
          )}
        >
          <div>
            <ProductSalesTargetBadge
              salesTargets={product.salesTargets}
              className="mb-4"
            />
            <p className="mb-4 truncate leading-[18px] text-[14px]">
              {product.productName}
            </p>
            <ProductPrice {...product} reverse wFull={false} />
            <DeliveryFlag flags={product.deliveryFlags} />
          </div>
        </LinkComponent>
      </div>
      <div className="ml-16 flex shrink-0 basis-32 items-center">
        {isLoggedIn ? (
          <ShoppingCartButton item={product} onClick={onClickCart} />
        ) : (
          <NonLoginShoppingCartButton className="mb-0 mr-0" />
        )}
      </div>
    </div>
  );
};

export default PopularProductItem;
